const cadastro_de_reordenamento_a_partir_do_planejamento = {
  path: "/cadastro-de-reordenamento-a-partir-do-planejamento",
  redirect: "/cadastro-de-reordenamento-a-partir-do-planejamento",
  meta: {
    breadCrumb: "Processo de Matrículas - Registrar Reordenamento",
  },
  children: [
    {
      path: "/cadastro-de-reordenamento-a-partir-do-planejamento",
      name: "cadastro_de_reordenamento_a_partir_do_planejamento",
      component: () =>
        import(
          "@/views/CadastroDeReordenamentoAPartirDoPlanejamento/CadastroDeReordenamentoAPartirDoPlanejamentoHome.vue"
        ),
    },
  ],
};

export { cadastro_de_reordenamento_a_partir_do_planejamento };
